<script>
export default {
  name: 'InputField',
  props: {
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: 'Enter value...'
    },
    required: {
      type: Boolean,
      default: true
    },
    validation: {
      type: Object,
      required: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    errors () {
      if (this.validation) {
        return this.validation.$errors[0] ? this.validation.$errors[0].$message : ''
      }
      return ''
    }
  }
}
</script>

<template>
  <div>
    <label
        :for="label"
        class="block mb-2 text-sm font-medium text-gray-900"
    >
      {{ label }}
    </label>
    <input
        :type="type"
        :name="label"
        :value="modelValue"
        :id="label"
        class="bg-gray-50 border border-gray-300 text-gray-900 rounded-xl focus:ring-primary-700 focus:border-primary-700 block w-full p-2.5"
        :placeholder="placeholder"
        :required="required"
        :disabled="disable"
        @input="$emit('update:modelValue', $event.target.value)"
    >
    <p class="mt-2 text-sm text-red-600 dark:text-red-500">
      {{ errors }}
    </p>
  </div>
</template>